import { useRoutes } from "react-router-dom";
import Listroutes from "./routes/Router";
import React, { useState, useEffect } from "react";
import axios from "axios";

const App = () => {
  const routing = useRoutes(Listroutes);
  const [isIpValidated, setIsIpValidated] = useState(null);
  useEffect(() => {
    // Limpiar localStorage al cargar la página
    localStorage.removeItem("isIPValidated");
    localStorage.removeItem("isIPDenied");
    localStorage.removeItem("alertShown");

    // Función para obtener la IP y validarla
    const validateIP = async () => {
      let clientIp = localStorage.getItem("clientIp");

      // Se pide siempre: si la IP del usuario cambia, la guardada lo bloquearía.
      // fetch sin cabeceras: con axios (interceptor + defaults) el navegador
      // mandaba un OPTIONS previo que ipify no responde (520).
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        clientIp = data.ip;
        localStorage.setItem("clientIp", clientIp); // Guardamos la IP
      } catch (error) {
        if (!clientIp) {
          console.error("Error al obtener la IP", error);
          setIsIpValidated(false); // IP no válida
          localStorage.setItem("isIPValidated", "false");
          localStorage.setItem("isIPDenied", "true");
          return;
        }
      }

      // Validamos la IP
      try {
        const response = await axios.get("/api/v1/ip-validador", {
          headers: {
            "X-Client-IP": clientIp,
            Accept: "application/json",
          },
          withCredentials: false, // Deshabilitar withCredentials solo para esta solicitud
        });

        if (response.status === 200) {
          localStorage.setItem("isIPValidated", "true");
          localStorage.setItem("isIPDenied", "false");
          setIsIpValidated(true); // IP válida

        }
      } catch (error) {
        console.error("Error al validar la IP:", error);
        localStorage.setItem("isIPValidated", "false");
        localStorage.setItem("isIPDenied", "true");
        setIsIpValidated(false); // IP no válida

        // Mostrar el alert solo una vez
        if (!localStorage.getItem("alertShown")) {
          alert("Acceso no permitido: IP no válida");
          localStorage.setItem("alertShown", "true"); // Marcamos que ya se mostró el alert
        }
      }
    };

    validateIP(); // Ejecutamos la validación de la IP al montar el componente
  }, []);

  // Mientras validamos la IP, mostramos un mensaje de carga
  if (isIpValidated === null) {
    return <div>Validando IP...</div>;
  }

  // Si la IP está validada, renderizamos la aplicación
  if (isIpValidated === false) {
    return (
      <div style={styles.deniedMessage}>
        <h2>Acceso Denegado</h2>
        <p>No tienes acceso a esta aplicación.</p>
      </div>
    ); // Si la IP no es válida, mostramos el mensaje de denegación
  }

  return routing;
};

// Estilos en línea para el mensaje de "Acceso Denegado"
const styles = {
  deniedMessage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "#fff",
    textAlign: "center",
    padding: "20px",
    flexDirection: "column",
    fontFamily: "'Arial', sans-serif",
  },
};
export default App;
